<!DOCTYPE html>
<html lang="en">
<head>
   <title> Edit Monthly Projection </title>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-Content-Type-Options" content="nosniff">
</head>
<body>
<div class="card-pad">
   <div class="fr-flex__container sticky-sub-header">
      <div class="fr-flex__col-6">
         <h3>Edit Monthly Projection</h3> 
      </div>
      <div class="fr-flex__col-6 custom-pad-right-zero">  
         <div class="preview_section pull-right">
            <button  [class.previous]="currentIndex !== 0"  (click)="pageChangeConfirmation(2)" [disabled]="currentIndex === 0"><i class="pi pi-arrow-up" pTooltip="Preview" tooltipPosition="top"></i></button>
            <span class="numbers_list">{{getCurrentPositionText()}}</span>
            <button [class.next]="currentIndex !== listOfForecasts.length - 1" (click)="pageChangeConfirmation(1)"  [disabled]="currentIndex === listOfForecasts.length - 1"><i class="pi pi-arrow-down" pTooltip="Next" tooltipPosition="top"></i></button>
            </div> 
         </div>
   </div>
   <div class="scroll-start-here-sub-tabs"> 
<form [formGroup]="forecastForm"> 
   <div class="fr-flex__container m-t-20">
      <div class="fr-flex__col-4">
         <div class="fr-form__group">
            <label> Month  <em> * </em></label>
              <input type="text" class="form-control read-only" pInputText value="{{ forecastDetail.forecastDate | date:'MMMM yyyy' }}" readonly="readonly"/>
         </div>

        
      </div>
      <div class="fr-flex__col-4">
        <div class="fr-form__group">
           <label> Projected Spend   <em> * </em></label>
           <p-inputNumber formControlName="_forecastedAmount" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="2" class="form-control-inputNumber" type="text" [maxlength]="15" [(ngModel)]="forecastDetail.forecastedAmount"/>
           <small class="p-error" *ngIf="forecastSubmitted && forecastForm?.get('_forecastedAmount')?.hasError('required')">This field is required.</small>
           <small class="p-error" *ngIf="forecastSubmitted && forecastForm?.get('_forecastedAmount')?.hasError('pattern')"> Only numbers allowed and maximum 15 digits which includes 2 decimal places. </small>
           <small class="p-error" *ngIf="forecastSubmitted && forecastForm?.get('_forecastedAmount')?.hasError('maxlength')">   Maximum length is 15 characters. </small>
               
        </div>
     </div>
 <div class="fr-flex__col-4">
        <div class="fr-form__group">
      <label> Attachments <i pInputText pTooltip="Maximum 3 Attachments allowed." tooltipPosition="top"
            class="pi pi-info-circle"> </i></label>
      <input type="file" accept=".pdf, .xls, .xlsx,.doc,.docx" multiple (change)="onFileChange($event)"
         class="form-control" formControlName="_forecastFile" #fileInput style="display:none;" trimSpace />
      <button type="button" (click)="fileInput.click()" class="form-control" style="width: 100%;"
         [disabled]="isUploadButtonDisabled">Upload Files</button>
      <div class="display-inline-block" *ngFor="let file of uploadedFiles">
         <a class="form-list-active" (click)="downloadAttachment(file)">
            <span [pTooltip]="file.name.length > 40 ? file.name : ''" tooltipPosition="top"> {{ file.name | truncate: 40
               }} </span>
            <i pInputText pTooltip="Delete" tooltipPosition="top" (click)="removeFile(file)"
               class="pi pi-trash"></i>
         </a>
      </div>

   </div>

</div>



   </div>
   <div class="fr-flex__container">
    <div class="fr-flex__col-12">
      <div class="fr-form__group">
         <label> Remarks <span class="max-length"> {{forecastDetail.remarks?.length || 0}}/300 </span> </label>
         <textarea class="form-control" formControlName="_remarks" pInputTextarea [(ngModel)]="forecastDetail.remarks" [maxlength]="300"></textarea>
      </div>
   </div>
   </div>
</form>


<div class="fr-flex__container">

   <div class="fr-flex__col-3">
      <div class="fr-form__view">
         <label> Modified By</label>
         <span  *ngIf="updatedBy !=null"> <em>  {{updatedBy}} </em></span>
         <span *ngIf="updatedBy == null || updatedBy == undefined || updatedBy == ''"> <em> -- </em></span>
      </div>
   </div>
   <div class="fr-flex__col-3" >
      <div class="fr-form__view">
         <label> Modified Date & Time </label>
         <span  *ngIf="updatedBy !=null && updatedBy != undefined && updatedBy != ''"> <em> {{forecastDetail?.updatedDate | date: _dateformart.DateTimeWithZone }} {{_dateformart.DisplayUTC}}</em></span>
          <span *ngIf="updatedBy ==null || updatedBy == undefined || updatedBy == ''"> <em> -- </em></span>
        </div>
   </div>
</div>
</div>


   <!-- Save & Cancel Footer buttons Start -->
   <div class="fr-flex__container footer_btns">
      <div class="fr-flex__col-12">
         <button routerLinkActive="active" type="button" class="btn btn-primary btn-save pull-right" [class.disabled]="isSaveBtnDisable" (click)="isSaveBtnDisable ? null : saveContractForecast()" > Save </button>
         <button type="button" class="btn btn-secondary pull-right" (click)="onCancelContractForecast()" > Cancel </button>
   </div>
</div>

</div>
</body>
</html>
<!-- Save & Cancel Footer buttons  End -->

